import { render, staticRenderFns } from "./reset-password.html?vue&type=template&id=38f0f968&"
import script from "./reset-password.js?vue&type=script&lang=js&"
export * from "./reset-password.js?vue&type=script&lang=js&"
import style0 from "./reset-password.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports